import { addressHelpers } from '../routes/helpers';
import { AppointmentDurationEstimation, YourProducts } from '../components';
import { AppointmentInformation } from '../components/appointment-information';
import { msToPartDayTime } from '~/routes/utils';
import { getEstimationTimeForAllProducts } from '~/ocab-services/measure/utils';

export const config = {
  BookingReview: {
    displayPropertyAddress: true,
    hideShopDetails: true,
    hidePriceDetails: true,
    hidePartnerDetails: true,
    hideAddToCalendarButton: false,
    hideManageAppointmentsButton: true,
    formatBookingAddressFunc: addressHelpers.formatBookingPropertyAddress,
    BookingAddress: {
      title: 'Property Address',
    },
    BookingDate: {
      formatTimeSlot: startTime => msToPartDayTime(startTime),
      appointmentDurationEstimationComponent: AppointmentDurationEstimation,
      buildAppointmentEstimationDurationDescription: duration => `Your appointment will last around ${duration}`,
    },
    icsEvent: {
      getTitle: ({ appointmentTypeTitle }) => `John Lewis ${appointmentTypeTitle} measuring service`,
      getAppointmentInfoSection: appointmentTypeName => `John Lewis & Partners ${appointmentTypeName} at home measuring service`,
      getCustomAdditionalInfoSection: ({ products = [] } = {}) => (
        `\\nApproximate duration will be: ${getEstimationTimeForAllProducts(products)}`
        + '\\n\\nFor any questions regarding your appointment, or to amend or cancel please contact us on 0345 608 0850 or email furnishings.scheduling@johnlewis.co.uk'
      ),
    },
  },
  ItemListDetails: {
    sectionTitle: 'Your products',
    component: YourProducts,
  },
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
};
